module.exports = __webpack_public_path__ + "static/material-tooltip-rich-b6b6b295b0915e3a2a47ef680a1a6278.png";